import { createFeatureSelector } from '@ngrx/store';
import { DialogState } from './state';

export const dialogFeatureKey = 'dialogFeature';

export const selectFeatureState = createFeatureSelector<DialogState>(dialogFeatureKey);
